<template>
  <codici-iva />
</template>

<script>
import CodiciIva from '@/components/ask/pages/tesoreria/CodiciIva.vue'

export default {
  name: 'PageTesoreriaCodiciIva',

  components:{
    CodiciIva
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
